// 先从index文件中按分类搬过来 测试没时间详细测试 所以先不做方法的优化 方法原模原样先搬到对应文件中 保证调用方式正确即可

import moment from 'moment';

import request from 'api/request';
import { ApiMap } from 'api/config';
import XJJSBridge from 'tools/JsBridge';
import { locStorage } from './libs/locStorage';
import { getCookie } from './libs/cookie';
import { sourceEnum, sceneEnum } from 'pages/enums/point';
import { TXMD_IS_CASH_ALL, TXMD_IS_PICK_TERM, TXMD_IS_SEE_PLAN } from 'pages/constants';
import { is58App, isHaojieApp, isApp, isHaojieSDK, isIos, isAndroid, getOS, getOSVersion, isWeChatMiniWithSync } from './UA';

/**
 * @description: 获取用户58Id
 * @return: string 58id
 */
const get58Id = (): string => {
    try {
        const ppu = getCookie('PPU');

        if (!ppu) return 'unknow';

        return ppu.split('&')[0].split('=')[1];
    } catch (e) {
        return 'unknow';
    }
};

/**
 * @description: 获取页面来源
 */
const getSource = (): string => {
    // 小程序需要从cookie里获取source（平台首页埋入的）未获取到现在写死『h5_xiaochengxu』
    if (isWeChatMiniWithSync())
    // if (isWechat())
        return getCookie("source") || sourceEnum[9];
    if (!isApp() && !isHaojieSDK()) return sourceEnum[0];

    const isAndroidSystem = isAndroid();
    const isIosSystem = isIos();
    const is58 = is58App();
    const isHaojie = isHaojieApp();
    const isSDK = isHaojieSDK();

    if (isIosSystem && is58) {
        return sourceEnum[1];
    }

    if (isAndroidSystem && is58) {
        return sourceEnum[3];
    }

    if (isIosSystem && isHaojie) {
        return sourceEnum[2];
    }

    if (isAndroidSystem && isHaojie) {
        return sourceEnum[4];
    }

    if (isAndroidSystem && isSDK) {
        return sourceEnum[6];
    }

    if (isIosSystem && isSDK) {
        return sourceEnum[5];
    }

    return sourceEnum[0];
};

/**
 * @description: 获取屏幕分辨率
 */
const getResolutionRatio = (): string => {
    try {
        return `${window.screen.width * window.devicePixelRatio}x${window.screen.height * window.devicePixelRatio}`;
    } catch (e) {
        return '';
    }
};

/**
 * @description: 单独获取风控相关设备信息
 */
const getRiskInfo = (): object => {
    try {
        return {
            os: getOS(),
            osv: getOSVersion(),
            ppi: getResolutionRatio()
        };
    } catch (e) {
        return {};
    }
};

interface Point {
    [props: string]: any;
}

/**
 * 风控埋点数据上报调用函数
 * @param params {Object} 埋点数据
 */
const riskBuryPoint = (params: Point): void => {
    try {
        const pointData: Point = {};
        const { duration, ...others } = params;
        const data: Point = {
            duration,
            timeStamp: moment().format('YYYY-MM-DD HH:mm:ss SSS'),
        };
        const info = {
            // 页面来源
            source: getSource(),
            // 业务线id
            businessId: '100102006',
        };

        // 调用native方法获取相关埋点数据
        try {
            // 2022.1.20需完成58同城合规整改的需求：http://fwiki.58corp.com/pages/viewpage.action?pageId=70766027 设备和位置信息 需要前端获取发送给风控写到header上
            // 58同城11.0.0的包提供新方法get_device_data和start_compliance_location来完成设备信息和位置信息的获取
            const alive_action_list = window.alive_action_list || [];
            if (alive_action_list.indexOf('get_device_data') >= 0 && alive_action_list.indexOf('start_compliance_location') >= 0) {
                // 一个账号一天同一场景值获取并发送风控一次，不可多次获取并发送
                Object.assign(pointData, info, others, { data: JSON.stringify(data) });
                const value = `${(new Date()).toLocaleDateString()}${get58Id()}`;
                const { isSupport, set, get } = locStorage;

                if (isSupport() && get(pointData.scene) === value) {
                    return;
                }

                const ACTION_TOKEN = '519eabgd1b0e279d11112';
                const DOMAIN = 'haojie.58.com/.*';
                let headerParams = { sdpsceneid: 44 }; // 风控在信安申请的 信安根据这个值来解密位置信息和设备信息（目前可能没什么用）
                window.WBAPP.invoke('get_device_data', {
                    compliance_token: ACTION_TOKEN,
                    compliance_regex: DOMAIN,
                }, function (deviceData) {
                    const { sdpdevicedata } = JSON.parse(deviceData) || {};
                    Object.assign(headerParams, { sdpdevicedata });

                    window.WBAPP.invoke('start_compliance_location', {
                        compliance_token: ACTION_TOKEN,
                        compliance_regex: DOMAIN,
                    }, (locationInfo) => {
                        const { code, sdplocdata } = JSON.parse(locationInfo) || {};
                        if (code === '0') {
                            Object.assign(headerParams, { sdplocdata });
                        }

                        set(pointData.scene, value);
                        request.post(ApiMap.riskPoint, { headerParams, ...pointData });
                    });
                });
                return;
            }

            if (isApp()) {
                XJJSBridge.invoke('get_user_info', (deviceData: any) => {
                    let deviceInfo: any = typeof deviceData === 'string' && deviceData ? JSON.parse(deviceData) : deviceData;
                    let newInfo = { ...data, ...deviceInfo };
                    // 合并相关埋点信息
                    Object.assign(pointData, info, others);

                    pointData.data = JSON.stringify(newInfo);

                    XJJSBridge.invoke('is_login', (state: string) => {
                        // 若没有登陆 过滤掉mac地址
                        if (state !== '0') {
                            const array = ['m', '58mac', 'mac'];
                            let temp = {};

                            // 过滤掉mac数据
                            for (let key in newInfo) {
                                if (array.indexOf(key) === -1) {
                                    temp[key] = newInfo[key];
                                }
                            }

                            pointData.data = JSON.stringify(temp);
                        }

                        // 上报风控埋点相关的数据
                        request.post(ApiMap.riskPoint, pointData);
                    });
                });

                return;
            }

            if (isHaojieSDK()) {
                XJJSBridge.invoke('get_user_info', (deviceData: any) => {
                    let deviceInfo: any = typeof deviceData === 'string' && deviceData ? JSON.parse(deviceData) : deviceData;
                    let newInfo = { ...data, ...deviceInfo };
                    // 合并相关埋点信息
                    Object.assign(pointData, info, others);

                    pointData.data = JSON.stringify(newInfo);
                    // 上报风控埋点相关的数据
                    request.post(ApiMap.riskPoint, pointData);
                });
                return;
            }

            // 微信小程序数据上报（2024.3.14）：https://docs.58corp.com/#/space/1759502297404080128
            // if (isWechat()) {
            if (isWeChatMiniWithSync()) {
                // 获取Cookie中的source
                getWXLocation().then((location)=> {
                    // 获取位置信息
                    let newInfo = { ...data, ...location};
                    // 合并相关埋点信息
                    Object.assign(pointData, info, others);
                    pointData.data = JSON.stringify(newInfo);
                    console.log("pointData=>", pointData);
                    request.post(ApiMap.riskPoint, pointData);
                });
                return;
            };

        } catch (e) {
        console.log(e);
    }

    // 合并相关埋点信息
    Object.assign(pointData, info, others);

    pointData.data = JSON.stringify({ ...data, ...getRiskInfo() });

    request.post(ApiMap.riskPoint, pointData);
} catch (e) {
    console.log(e);
}
};

/**
 * 风控埋点调用函数 专门给神奇矿用的
 * @param params {Object} 埋点数据
 */
const riskBuryPointForAsyncSqk = (params: Point) => {
    return new Promise(async (resolve) => {
        try {
            const pointData: Point = {};
            const { duration, ...others } = params;
            const data: Point = {
                duration,
                timeStamp: moment().format('YYYY-MM-DD HH:mm:ss SSS'),
            };
            const info = {
                // 页面来源
                source: getSource(),
                // 业务线id
                businessId: '100102006',
            };

            // 调用native方法获取相关埋点数据
            try {
                if (isApp()) {
                    XJJSBridge.invoke('get_user_info', async (deviceData: any) => {
                        let deviceInfo: any = typeof deviceData === 'string' && deviceData ? JSON.parse(deviceData) : deviceData;
                        let newInfo = { ...data, ...deviceInfo };
                        // 合并相关埋点信息
                        Object.assign(pointData, info, others);

                        pointData.data = JSON.stringify(newInfo);

                        await XJJSBridge.invoke('is_login', async (state: string) => {

                            // 若没有登陆 过滤掉mac地址
                            if (state !== '0') {
                                const array = ['m', '58mac', 'mac'];
                                let temp = {};

                                // 过滤掉mac数据
                                for (let key in newInfo) {
                                    if (array.indexOf(key) === -1) {
                                        temp[key] = newInfo[key];
                                    }
                                }

                                pointData.data = JSON.stringify(temp);
                            }
                            // 上报风控埋点相关的数据
                            const res = await request.post(ApiMap.riskPoint, pointData);

                            res && resolve('success');
                        });
                    });
                    return;
                }

                if (isHaojieSDK()) {
                    XJJSBridge.invoke('get_user_info', async (deviceData: any) => {
                        let deviceInfo: any = typeof deviceData === 'string' && deviceData ? JSON.parse(deviceData) : deviceData;
                        let newInfo = { ...data, ...deviceInfo };
                        // 合并相关埋点信息
                        Object.assign(pointData, info, others);

                        pointData.data = JSON.stringify(newInfo);
                        // 上报风控埋点相关的数据
                        const res = await request.post(ApiMap.riskPoint, pointData);

                        res && resolve('success');
                    });
                    return;
                }

            } catch (e) {
                console.log(e);
            }
            // 合并相关埋点信息
            Object.assign(pointData, info, others);

            pointData.data = JSON.stringify({ ...data, ...getRiskInfo() });

            const res = await request.post(ApiMap.riskPoint, pointData);

            res && resolve('success');
        } catch (e) {
            console.log(e);
        }
    })
};

/**
 * 风控借款流程时间段上报函数
 * @param params {Object} 埋点数据 isNeedUpload {boolean} 是否需要上报截屏录屏等信息
 */
const riskBuryTimestampPoint = (params: Point, isNeedUpload = false): void => {
    try {
        let pointData: Point = {};
        const { behavior = '', startTime = '', endTime = '', scene = '', ...others } = params;
        const info = {
            // 页面来源
            source: getSource(),
            // 业务线id
            businessId: '100102006',
            // scene写死为withDraw
            scene: sceneEnum[3]
        };

        // 调用native方法获取相关埋点数据
        if (isHaojieApp() && isNeedUpload) {
            XJJSBridge.invoke('get_user_info', (deviceData: any) => {
                let deviceInfo: any = typeof deviceData === 'string' && deviceData ? JSON.parse(deviceData) : deviceData;
                let { app_back_times = [], scr_shot_times = [], scr_record_times = [] } = { ...deviceInfo };
                let switchOutTime = (app_back_times && app_back_times.length > 0 && app_back_times.map(a => a.timestamp)) || [];
                let screencapStartTime = (scr_record_times && scr_record_times.length > 0 && scr_record_times.map(sr => sr.timestamp)) || [];
                let printScreenTime = (scr_shot_times && scr_shot_times.length > 0 && scr_shot_times.map(s => s.timestamp)) || [];
                pointData = {
                    behavior,
                    scene,
                    data: {
                        startTime,
                        endTime,
                        switchOutTime,
                        screencapStartTime,
                        printScreenTime,
                        ...others
                    }
                };
                // 合并相关埋点信息
                Object.assign(pointData, info);
                request.post(ApiMap.riskPointTimestamp, pointData);
            });
        } else {
            pointData = {
                behavior,
                scene,
                data: {
                    startTime,
                    endTime,
                    ...others
                }
            };
            request.post(ApiMap.riskPointTimestamp, { ...pointData, ...info });
        }
    } catch (e) {
        console.log(e);
    }
};

/**
 * 活动页跳过好借首页，进入好借流程内部上报风控
 */
const riskDataForActivityReport = ({ scene }) => {
    const info = {
        // 页面来源
        source: getSource(),
        // 业务线id
        businessId: '100102501',
    };
    try {
        if (isHaojieSDK() || isHaojieApp()) {

            XJJSBridge.invoke('get_app_device_info', (deviceData) => {
                let deviceInfo: any = typeof deviceData === 'string' && deviceData ? JSON.parse(deviceData) : deviceData;
                let _data = { scene, ...info, data: JSON.stringify(deviceInfo) };

                request.post(ApiMap.riskPoint, _data);
            });
        } else {
            let _data = { scene, ...info, data: JSON.stringify({ ppi: getResolutionRatio() }) }
            request.post(ApiMap.riskPoint, _data);
        }
    } catch (error) {
        console.log(error);
    }
};

/**
 * 初始化风控埋点值 需求文档http://fwiki.58corp.com/pages/viewpage.action?pageId=45503458
 */
const initClickRiskBuryPoint = () => {
    try {
        // 有点击行为上报值为1，无点击行为，上报值为0 (在借款输入手机号验证码时调用)
        localStorage.setItem(TXMD_IS_PICK_TERM, '0'); // 还款期数是否点击
        localStorage.setItem(TXMD_IS_SEE_PLAN, '0'); // 还款计划是否点击
        localStorage.setItem(TXMD_IS_CASH_ALL, '0'); // 全部借出是否点击
    } catch (e) {
        console.log(e);
    }
};

/**
 * 设置风控埋点值
 */
const setClickRiskBuryPoint = (key: string): void => {
    try {
        localStorage.setItem(key, '1'); // 点击了赋值为1
    } catch (e) {
        console.log(e);
    }
};

/**
 * @description: 上报错误埋点
 * @param {string} desc 错误描述
 * @param {string} orderId 当前该笔人脸的订单号码
 */
const reportError = (desc: string, orderId = ''): void => {
    try {
        let source = 'others';

        if (is58App()) {
            source = '58app';
        } else if (isHaojieApp()) {
            source = 'haojieApp';
        } else if (isHaojieSDK()) {
            source = 'haojieSDK';
        }

        desc = typeof (desc) === 'object' ? JSON.stringify(desc) : desc;

        const err = new Error(`${source}(${get58Id()} | ${orderId || null}) -----> ${desc}`);
        const Beidou = window.Beidou;
        Beidou && Beidou.captureException(err);
    } catch (e) {
        console.log(e);
    }
};

/**
 * 业务埋点上报
 * @param params 上报的数据
 */
const riskBusinessPoint = (params: Point): void => {
    try {
        Object.assign(params, {
            // 页面来源
            source: getSource(),
            timeStamp: moment().format('YYYY-MM-DD HH:mm:ss SSS')
        });

        // 好借app中需要从设备信息中单取出来相关信息上报
        if (isHaojieApp()) {
            XJJSBridge.invoke('get_user_info', (deviceData: any) => {
                const deviceInfo: any = typeof deviceData === 'string' && deviceData ? JSON.parse(deviceData) : deviceData;
                const { cid, imei, dID, sID } = deviceInfo;

                Object.assign(params, {
                    cid: cid || '',
                    imei: imei || '',
                    deviceId: dID || '',
                    smartId: sID || ''
                });

                // 上报相关数据
                request.post(ApiMap.businessPoint, params);
            });
            return;
        }

        // 非好借app直接上报数据即可
        request.post(ApiMap.businessPoint, params);
    } catch (e) {
        console.log(e);
    }
};

/**
 * 北斗上报微信异常
 * @param params 上报的数据
 */
const captureExceptionByWx = (info: any): any => {
    const Beidou = window.Beidou;
    if (window.location.hostname !== "haojie.58.com") {
        console.error(info);
    } else if (Beidou) {
        Beidou.captureException(new Error('jr_xj_hj_wx_config_exception'), {
            tags: {
                ...info
            }
        });
    }
};

/**
 * 获取微信位置信息
 * @returns 返回定位结果
 */
const getWXLocation = async (): Promise<any> => {
    return new Promise((resolve, reject) => {
        const wx = window.wx;
        console.log('wx=>', wx);
        // 获取微信定位
        wx && wx.ready(() => {
            console.log('wxReady');
            
            wx.getLocation({
                type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                success: async function (res) {
                    console.log('wxminiInfo', 'wx.getLocation', 'success', res);
                    const { latitude, longitude } = res;
                    const _res = { latitude, longitude };
                    resolve(_res);
                },
                cancel: function (res) {
                    console.log('wxminiInfo', 'wx.getLocation', 'cancel', res);
                    resolve({ latitude: 0, longitude: 0 });
                },
                fail: (res) => {
                    console.log('wxminiInfo', 'wx.getLocation', 'fail', res);
                    resolve({ latitude: 0, longitude: 0 });
                }
            });
        });
        // 监听初始化失败
        wx && wx.error(() => {
            console.log('未授权位置获取请求');
            resolve({ latitude: 0, longitude: 0 });
        })
    });
}

export {
    riskBuryPoint,
    riskBuryPointForAsyncSqk,
    riskBuryTimestampPoint,
    riskDataForActivityReport,
    initClickRiskBuryPoint,
    setClickRiskBuryPoint,
    reportError,
    riskBusinessPoint,
    captureExceptionByWx,
}